import { TextArea as FaveTextArea, FormItem, TextAreaProps } from 'fave-ui';
import { useFormikContext } from 'formik';
import formStyles from '../style.module.css';
import { cn } from '../../../../helpers/cn';

type Props<T> = { name: keyof T; label: string } & TextAreaProps;

const TextArea = <T extends {}>({
  name,
  value,
  label,
  className,
  disabled,
  ...restProps
}: Props<T>) => {
  const {
    errors,
    touched,
    handleBlur,
    values,
    setFieldValue,
    setFieldTouched,
  } = useFormikContext<T>();

  const innerValue = (values[name] as unknown as string) || value;
  const error = errors[name] as unknown as string;
  const isTouched = touched[name] as unknown as string;
  const helpText = isTouched && error !== undefined && error;

  return (
    <FormItem
      className={cn(formStyles.formItem)}
      label={label}
      validateStatus={error !== undefined && isTouched ? 'error' : 'success'}
      help={helpText}
    >
      <FaveTextArea
        {...restProps}
        disabled={disabled}
        bordered={true}
        name={name}
        onChange={e =>
          handleChange(
            e as unknown as React.ChangeEvent<HTMLInputElement>,
            setFieldValue,
          )
        }
        onBlur={e => {
          handleBlur(e);
          setFieldTouched(name as string, true, true);
        }}
        value={innerValue}
        className={cn(className)}
      />
    </FormItem>
  );
};

const handleChange = (
  e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>,
  setFieldValue: (
    field: string,
    value: boolean | string | number | Date,
    shouldValidate?: boolean | undefined,
  ) => void,
) => {
  const { name, value } = e.target;
  const { valueAsNumber, valueAsDate } = e.target as HTMLInputElement;

  const newValue = valueAsDate || valueAsNumber || value;

  setFieldValue(name, newValue, true);
};

export default TextArea;
